import React, { PropTypes } from 'react';
import RenderField from '../../../FormTemplate/InputControl';
import { Field } from 'redux-form';
import { Button, Table } from 'react-bootstrap';
import SelectAsync from './../../../FormTemplate/SelectAsync';
import Select from './../../../FormTemplate/Select';

class FormFixedAssetList extends React.Component {
   render() {
      const { fields, fixedAssetAccounts } = this.props;
      return (
         <div>
            <Table>
               <thead>
               <tr>
                  <th>Asset Name</th>
                  <th>Amount</th>
                  <th>Salvage Value</th>
                  <th>Asset Type</th>
                  <th>##</th>
               </tr>
               </thead>
               <tbody>
               {fields.map((item, index) =>
                  <tr key={index} >
                     <td className="col-md-6" >
                        <Field
                           name={`${item}.item_id`}
                           type="text"
                           minimumInput={2}
                           link="fixedAssets/itemSearchByName"
                           component={SelectAsync} />
                     </td>
                     <td>
                        <Field
                           name={`${item}.price`}
                           type="number"
                           component={RenderField} />
                     </td>
                     <td>
                        <Field
                           name={`${item}.salvage_value`}
                           type="number"
                           component={RenderField} />
                     </td>
                     <td className="col-md-3" >
                        <Field
                           name={`${item}.account_id`}
                           allowEmpty={true}
                           options={fixedAssetAccounts}
                           component={Select} />
                     </td>
                     <td>
                        {(index > 0) && <Button onClick={() => fields.remove(index)} >remove</Button>}
                     </td>
                  </tr>
               )}
               </tbody>
            </Table>
            <Button onClick={() => fields.push({})} >Add Another Asset</Button>
         </div>
      );
   }
}

FormFixedAssetList.propTypes = {
   fields: PropTypes.object,
   fixedAssetAccounts: PropTypes.array
};

export default FormFixedAssetList;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/FixedAsset/FormHelper/FormFixedAssetList.js
 **/